import type { ModelTypes } from '@zeus/index'
import type { TFunction } from 'i18next'
import type { ReportTemplate } from '~/gql/reports/reports'
import { ReportFrequency } from '@zeus/index'

/** Le réglage de l'envoi d'un modèle par mail (#163), en fonctions pures. */
export type ScheduleForm = {
  enabled: boolean
  frequency: ReportFrequency
  /** 1 = lundi … 7 = dimanche. */
  weekday: number
  /** 1 à 28 : tous les mois ont ces jours-là. */
  monthDay: number
  /** Heure locale de l'organisation. */
  hour: number
  recipientIds: string[]
}

/** Un envoi pas encore programmé part sur « le 1er du mois à 7 h ». */
export function scheduleFormFrom(schedule: ReportTemplate['schedule']): ScheduleForm {
  return {
    enabled: schedule?.enabled ?? true,
    frequency: schedule?.frequency ?? ReportFrequency.MONTHLY,
    weekday: schedule?.weekday ?? 1,
    monthDay: schedule?.monthDay ?? 1,
    hour: schedule?.hour ?? 7,
    recipientIds: schedule?.recipientIds ?? [],
  }
}

export function toScheduleInput(form: ScheduleForm): ModelTypes['ReportScheduleInput'] {
  const weekly = form.frequency === ReportFrequency.WEEKLY
  return {
    enabled: form.enabled,
    frequency: form.frequency,
    weekday: weekly ? form.weekday : undefined,
    monthDay: weekly ? undefined : form.monthDay,
    hour: form.hour,
    recipientIds: form.recipientIds,
  }
}

/** L'envoi en quelques mots, pour la liste : « Mensuel : le 1, 7 h », ou un tiret sans envoi actif. */
export function scheduleSummary(schedule: ReportTemplate['schedule'], t: TFunction): string {
  if (!schedule?.enabled) return '—'
  const day = schedule.frequency === ReportFrequency.WEEKLY
    ? t(`reports.schedule.weekdays.${schedule.weekday}`)
    : String(schedule.monthDay)
  return t(`reports.schedule.summary.${schedule.frequency}`, { day, hour: schedule.hour })
}
